import styled from "@emotion/styled";

export const TooltipContainer = styled.div`
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const TooltipWrapper = styled.div<{
  maxWidth: number;
  position: Partial<DOMRect>;
}>`
  position: fixed;
  overflow: wrap;
  white-space: wrap;
  max-width: ${({ maxWidth }) => maxWidth}px;
  pointer-events: none;
  z-index: 1000;
  left: ${({ position }) => position.x}px;
  top: ${({ position }) => position.y}px;
  transition: opacity 0.2s ease-in-out;
`;

export const TooltipTail = styled.div`
  position: relative;
  left: 10px;
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #111827;
`;

export const TooltipBase = styled.div`
  height: 24px;
  background-color: #111827;
  gap: 8px;
  border-radius: 4px;
  padding: 8px 10px;
  box-shadow: 0px 1px 2px 0px #0e121b0f;
  box-shadow: 0px 12px 24px 0px #0e121b0f;
  font-weight: 500;
  font-size: 12px;
  leading-trim: Cap height;
  line-height: 100%;
  letter-spacing: -0.6%;
  vertical-align: middle;
  color: #ffffff;
`;
